<template>
  <div class="indexBox-Backgroud">
    <!-- @click.prevent="toRealName" -->
    <!-- 首页 登录成功
      login 页面code=103已注册 未退出登录-->

    <!-- 轮播图 -->
    <div class="swipe">
      <van-swipe :autoplay="3000" indicator-color="white">
        <van-swipe-item
          v-for="(image, index) in swipe"
          :key="index"
          class="swipeImg"
        >
          <img v-lazy="image.image" :src="image.image" class="swipeImg" />
        </van-swipe-item>
      </van-swipe>
    </div>

    <!-- 捐赠信息 
    <div class="donationRolling" v-if="allDonateRecord.length > 0">
      <div class="scroll-container">
        <div class="scroll-content">
          <div
            class="scroll-content-donation"
            v-for="(item, index) in allDonateRecord"
            :key="index"
          >
            {{ item.name }}:{{ item.totalMoney }}元
          </div>
        </div>
      </div>
    </div>
    -->
    <!-- 未读消息--列表滚动 -->
    <div class="scrolling">
      <div class="imgjb">
        <div class="nor">
          <img :src="btnGonggao" alt="喇叭" class="btnGonggaoImg" />
          <div class="nor-txt" v-if="noticeNum !== 0">
            {{ noticeNum }}
          </div>
        </div>
      </div>
      <div class="listscroll">
        <div
          v-if="noticeNum > 0"
          class="listscroll-box"
          :class="{ anim: animate }"
          @mouseenter="stop()"
          @mouseleave="up()"
        >
          <div
            v-for="(item, index) in notice"
            :key="index"
            class="list-item"
            @click="handleClick(item)"
          >
            <div class="noticeTitle">{{ item.content }}</div>
          </div>
        </div>
        <div v-else class="noticeTitle-rq">暂无消息</div>
      </div>
      <div class="imgjb-r">
        <div class="imgjbGengduo" @click="handleClick()">
          更多
          <img :src="btnGengduo" alt="右箭头" class="norimg" />
        </div>
      </div>
    </div>

    <!-- 消息通知 -->
    <!-- <div class="notice" v-if="this.notice != []">
        <div class="noticeImgDiv" @click="gotoNotice">
          <img
            src="../assets/image/"
            alt="通知图标"
            class="noticeImg"
          />
          <van-badge
            :content="this.notice.length"
            max="9"
            v-if="this.notice.length !== 0"
          >
          </van-badge>
        </div>
        <div class="noticeTitleDiv" style="background-color: antiquewhite;">
          <div class="noticeTitle" v-for="item in notice" :key="item.id">
            {{ item.content }}
          </div>
          <div class="noticeTitleDateDiv">
            <div
              class="noticeTitleDate"
              v-for="index in notice"
              :key="index.id + '_'"
            >
              {{ index.cre_date }}
            </div>
          </div>
          <div class="noticeMore">
            <img
              src="../assets/image/btn_gengduo_nor.png"
              alt="更多"
              @click="gotoNotice"
            />
          </div>
        </div>
      </div> -->

    <!-- 校友卡和捐赠div-->
    <div class="cardAndDonation clearfix">
      <div class="activeDetailsDiv">
        <div
          class="clearfix"
          style="width: 110vw; display: flex; flex-direction: row"
        >
          <!-- 校友卡 -->
          <div class="card" @click="gotoAlumniCard">
            <img :src="btnXiaoyouka" alt="校友卡" class="cardImg" />
            <div class="cardTitle">校友卡</div>
            <div class="cardWord">校友身份认证·尊享专属福利</div>
          </div>
          <!-- 校友之家 -->
          <div class="hommie" @click="gotoHommieList">
            <img :src="btnXiaoyouzhijia" alt="校友之家" class="hommieImg" />
            <div class="hommieTitle">校友之家</div>
            <div class="hommieWord">同根同源同梦·共进共享共赢</div>
          </div>
          <!-- 爱心捐赠 -->
          <div class="donation" @click="gotoDonation">
            <img
              src="../assets/image/btn_aixinjuanzeng_nor.png"
              alt="爱心捐赠"
              class="donationImg"
            />
            <div class="donationTitle">爱心捐赠</div>
            <div class="donationWord">饮水思源·点滴大爱</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 返校预约 -->
    <!-- <div class="backSchool" @click="gotoAppointment">
        <img
          src="../assets/image/btn_fanxiaoyuyue_nor.png"
          alt="返校预约"
          class="backSchoolImg"
        />
        <div class="backSchoolTitle">返校预约</div>
        <div class="backSchoolWord">秩年聚首·欢迎回家</div>
      </div> -->
    <!-- 成果转化 -->
    <!--       <div class="achievement" @click="gotoAchievement">
        <img src="../assets/image/btn_chengguo_nor.png" alt="返校预约" class="achievementImg" />
        <div class="achievementTitle">成果转化</div>
        <div class="achievementWord">展示成果·转化价值</div>
      </div> -->
    

    <!-- 母校动态 -->
    <div
      class="schoolRrunEnterprise clearfix"
      id="schoolRrunEnterpriseId"
      v-if="dynamic.length > 0"
    >
      <!-- <div class="titleDiv">
          <div class="activeTitleIcon"></div>
          <div class="activeTitleWord">母校动态</div>
          <button class="activeMore" @click="dynamicJump">更多</button>
        </div> -->
      <div class="FirstLevelTitle">
        <div>母校动态</div>
        <div @click="dynamicJump">更多</div>
      </div>
      <div class="activeDetailsDiv">
        <div
          class="clearfix"
          style="width: 225vw; display: flex; flex-direction: row"
        >
          <div
            class="activeDetails clearfix"
            v-for="item in dynamic"
            :key="item.id"
            @click="gotoDynamicDetail(item)"
          >
            <div class="listCard">
              <div class="card-list__itemone">
                <!-- <div
                  class="active-list__item-location"
                  v-if="item.newsType == 2"
                >
                  校友活动
                </div> -->
                <div class="active-list__item-location-y">{{item.typeNameById}}</div>

                <img class="headDiagram" :src="item.coverImg" />
              </div>
              <div class="dynamic-box-txt">
                <div>{{ item.title }}</div>
                <div>{{ item.uploadTime }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 交流合作 -->
    <div
      class="schoolRrunEnterprise clearfix"
      id="schoolRrunEnterpriseId"
      v-if="schoolList.length > 0"
    >
      <!-- <div class="titleDiv">
          <div class="activeTitleIcon"></div>
          <div class="activeTitleWord">交流合作</div>
          <button class="activeMore" @click="gotoSchoolRrunEnterprise">
            更多
          </button>
        </div> -->
      <div class="FirstLevelTitle">
        <div>交流合作</div>
        <div @click="gotoSchoolRrunEnterprise">更多</div>
      </div>
      <div class="activeDetailsDiv">
        <div
          class="clearfix"
          style="width: 225vw; display: flex; flex-direction: row"
        >
          <div
            class="activeDetails clearfix"
            v-for="item in schoolList"
            :key="item.id"
            @click="getScoolDetail(item)"
          >
            <div style="display: flex; flex-direction: row">
              <img class="schoolImg" :src="item.imgPath" />
              <div class="school-box-txt">
                <div>{{ item.companyName }}</div>
                <div>{{ item.intro }}</div>
                <div>
                  <img src="../assets/image/btn_guankan_nor.png" />
                  <div>{{ item.eyes }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 校友活动 -->
    <div class="active clearfix" id="activeId" v-if="false">
     <!-- v-if="active.length > 0" -->

      <div class="FirstLevelTitle">
        <div>校友活动</div>
        <div @click="gotoActiveList">更多</div>
      </div>

      <div class="activeDetailsDiv">
        <div class="clearfix xyhdDiv">
          <div
            class="activeDetails clearfix"
            v-for="item in active"
            :key="item.id"
            @click="gotoActiveDetial(item)"
          >
            <div style="display: flex; flex-direction: column">
              <div style="display: flex; flex-direction: row; width: 100%">
                <div class="city">{{ item.sh_city }}</div>
              </div>
              <img :src="item.sh_img" alt="图片" class="activeDetailsImg" />
              <div class="zhuangtai">
                <div class="zhuangtai-o">{{ item.sh_activity_status }}</div>
                <!-- <div class="zhuangtai-t">{{ item.shApplyNum }}人已报名</div> -->
              </div>
              <div class="line">
                <div class="line-o">[ {{ item.sh_label }} ]</div>
                <div class="line-t">{{ item.sh_title }}</div>
              </div>
              <div class="line">
                <img
                  src="../assets/image/btn_fangzi_nor.png"
                  alt="icon1"
                  class="line-Img"
                />
                <div class="line-xx">{{ item.sh_company }}</div>
              </div>
              <div class="line">
                <img
                  src="../assets/image/btn_shijian_nor.png"
                  alt="icon1"
                  class="line-Img"
                />
                <div class="line-xx">
                  {{ item.sh_start_time.slice(5) }}-{{ item.sh_end_time.slice(5) }}
                  <!-- {{ item.sh_start_time}}-{{ item.sh_end_time}} -->
                </div>
              </div>
              <div class="line" style="margin-bottom: 10px">
                <img
                  src="../assets/image/btn_dizhi_nor.png"
                  alt="icon1"
                  class="line-Img"
                />
                <div class="line-xx">{{ item.sh_address }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 各地校友 -->
    <div class="club clearfix" id="clubId" v-if="club.length > 0">
      <!-- <div class="titleDiv">
          <div class="activeTitleIcon"></div>
          <div class="activeTitleWord">各地校友</div>
          <button class="activeMore" @click="gotoAlumniMeeting">更多</button>
        </div> -->

      <div class="FirstLevelTitle">
        <div>各地校友</div>
        <div @click="gotoAlumniMeeting">更多</div>
      </div>

      <div class="activeDetailsDiv">
        <div class="clearfix gdxyDiv">
          <div
            class="activeDetails-fh clearfix"
            v-for="item in club"
            :key="item.id"
            @click="getBranchInDetai(item.id)"
          >
            <img
              v-if="item.img != '' && item.img != null"
              :src="item.img"
              alt="图片"
              class="fh-Img"
            />
            <div v-else class="fh-Img">暂无图片</div>
            <div class="fh-Title">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 校友资源 -->
    <div class="alumnus clearfix" id="alumnusId" v-if="alumnus.length > 0">
      <!-- <div class="titleDiv">
        <div class="activeTitleIcon"></div>
        <div class="activeTitleWord">校友资源</div>
        <button class="activeMore" @click="gotoAlumniResources">更多</button>
      </div> -->

      <div class="FirstLevelTitle">
        <div>校友资源</div>
        <div @click="gotoAlumniResources">更多</div>
      </div>
      <div class="alumnusDiv">
        <template v-if="alumnus.length > 0">
          <template v-for="item in alumnus">
            <AlumniInfoCard
              :key="item.id"
              :info="item"
              @go="gotoAlumnusDetail"
              class="alumni-card-box"
            ></AlumniInfoCard>
          </template>
        </template>
      </div>
    </div>

    <!-- 问卷调查 -->
    <div class="questionnaire clearfix" v-if="false">
      <!-- v-if="questionnaire.length > 0" -->
      <div class="FirstLevelTitle">
        <div>问卷调查</div>
        <div @click.prevent="gotoQuestionnaireList">更多</div>
      </div>
      <div
        v-for="(item, index) in questionnaire"
        :key="index"
        class="questionnaireDiv"
        @click="gotoQuestionnaireDetail(item.id)"
      >
        <img :src="btnWenjuandiaocha" alt="调查问卷" class="questionnaireImg" />
        <div class="questionnaireName">{{ item.name }}</div>
        <div class="questionnaireTime">
          {{ item.startTime }} 至少 {{ item.endTime }}
        </div>
      </div>
    </div>

    <!-- 底部标签 -->
  </div>
  <!-- </div> -->
</template>
<script>
import AlumniInfoCard from "./alumniResources/components/AlumniInfoCard/index.vue";
import { Swipe, SwipeItem } from "vant";
import btnGonggao from "@/assets/image/btn_gonggao_nor.png";
import btnGengduo from "@/assets/image/btn_gengduo_nor.png";
import btnXiaoyouka from "@/assets/image/btn_xiaoyouka_nor.png";
import btnXiaoyouzhijia from "@/assets/image/btn_xiaoyouzhijia_nor.png";
import btnWenjuandiaocha from "@/assets/image/btn_wenjuandiaocha_nor.png";
import Base64 from "@/utils/base64";
export default {
  components: {
    AlumniInfoCard,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
  data() {
    return {
      btnGonggao,
      btnGengduo,
      btnXiaoyouka,
      btnXiaoyouzhijia,
      btnWenjuandiaocha,
      // 请求的数据的对象
      postIndex: {
        user_id: window.localStorage.getItem("user_id"),
      },
      // 接受的数据的对象
      images: [
        // { url: require("@/assets/image/sy-img1.png") },
        { url: require("@/assets/image/sy-img2.png") },
        { url: require("@/assets/image/sy-img3.png") },
        { url: require("@/assets/image/sy-img4.png") },
        { url: require("@/assets/image/sy-img5.png") },
      ],
      timer: null,
      animate: false,
      notice: [],
      noticeTotal: "",
      club: [],
      alumnus: [],
      questionnaire: [],
      active: "",
      isRealNam: "",
      isReal: "",
      noticeNum: 0,
      userId: window.localStorage.getItem("user_id"),
      schoolList: [],
      allDonateRecord: [],
      // userId: "43995354",
      // 母校动态
      dynamic: [],
      authentication: 0, // 实名认证状态 0未认证 1 自动认证成功 2 人工认证成功 3 等待认证 4 人工认证失败
      authenticationReason: "",
      blockedByAuthentication: false,
    };
  },
  created() {
    if (!window.localStorage.getItem("phone")) {
      this.$router.push("/login");
      return;
    }
    this.initIndex();
  },

  mounted() {
    if (this.blockedByAuthentication) {
      return;
    }

    this.scrollUp(); // 开启滚动效果
  },

  methods: {
    async initIndex() {
      const canEnter = await this.checkAuthenticationAndRedirect();
      if (!canEnter) {
        return;
      }

      this.getSwipe(); //轮播图
      this.getAllDonateRecord(); //横向滚动条
      this.getDynamic(); //母校动态
      this.getSchool(); //交流合作
      this.getMsg(); //我的消息
      this.getActive(); //校友活动
      this.getClub(); //各地校友
      this.getAlumnus(); //校友资源
      // todo
      this.getQuestionnaire(); //问卷调查

      this.isRealNam = this.$route.query.realNam;
      /**
       * 实名认证你无关
       */
      // this.realName();
    },

    async checkAuthenticationAndRedirect() {
      const { authentication, authenticationReason } = await this.getLogin();

      // authentication=0 自动认证失败 -> failAuthentication
      // authentication=1/2 自动/人工认证通过 -> 正常访问 Index
      // authentication=3 认证中(等待人工认证) -> contactStaff
      // authentication=4 人工认证失败 -> failAuthentication 并展示原因
      if (authentication === 3) {
        this.blockedByAuthentication = true;
        await this.$router.replace({
          path: "/contactStaff",
        });
        return false;
      }

      if (authentication === 0 || authentication === 4) {
        this.blockedByAuthentication = true;
        await this.$router.replace({
          path: "/failAuthentication",
          query: {
            authentication: String(authentication),
            authenticationReason: authenticationReason || "",
          },
        });
        return false;
      }

      return true;
    },

    // // 实名认证你无关
    // async realName() {
    //   if (this.$route.query.status == 1) {
    //     this.isReal = this.$route.query.status;
    //     // 存入实名认证状态
    //     const res = await this.$http({
    //       // url: `/realNameAuthentication/realNameStatus?userId=${data.userId}&realNameAuthentication=${data.realNameAuthentication}`,
    //       url: `/realNameAuthentication/realNameStatus?userId=${localStorage.getItem(
    //         "user_id"
    //       )}&realNameAuthentication=1`,
    //       method: "POST",
    //       // data:data,
    //     });
    //     if (res.data.code == 200) {
    //       localStorage.setItem("realStatus", this.isReal);
    //       this.$toast("实名认证成功");
    //     } else {
    //       this.$toast("实名认证失败");
    //     }
    //   }
    // },

    async getLogin() {
      const base64 = new Base64();
      const rawPhone = window.localStorage.getItem("phone") == 'undefined' ? "" : window.localStorage.getItem("phone");
      const phone = base64.encode(rawPhone);
      console.info("phone", phone);
      const result = await this.$http.get(
        `/login/getOpenidAndUserId?phone=${phone}`
      );

      const data = result && result.data ? result.data : {};

      const authentication = Number(data.authentication);
      const authenticationReason = data.authenticationReason || "";

      this.authentication = Number.isNaN(authentication) ? 0 : authentication;
      this.authenticationReason = authenticationReason;

      return {
        authentication: this.authentication,
        authenticationReason: this.authenticationReason,
      };
    },
    // 获取母校动态
    async getDynamic() {
      const result = await this.$http.get("/amNews/getAmNews", {
        params: { currentPage: 1, perPage: 5 },
      });
      this.dynamic = result.data.list;
    },

    dynamicJump() {
      return this.$router.push("/dynamic");
    },
    
    gotoDynamicDetail(item) {
      return this.$router.push({
        path: "/dynamicDetails",
        query: {
          id: item.id,
        },
      });
    },

    // 全屏点击事件
    /**
     * 判断是否实名
     * code: 411未填写身份证  400未完成实名认证
     * */
    async toRealName() {
      const res = await this.$http({
        url: "/xjcard/selectSm",
        method: "get",
        params: {
          user_id: window.localStorage.getItem("user_id"),
        },
      });
      const { code, msg } = res.data;
      if (code === "411") {
        this.$toast(msg);
        await this.$router.push("/idSucess");
        return false;
      }
      if (code === "400") {
        this.$toast(msg);
        await this.$router.push("/completeInfo?isReal=false");
        return false;
      }
      return true;
    },
    async getSwipe() {
      const result = await this.$http.get("/bannersInHomePage/getImg");
      this.swipe = result.data;
      console.log("result--轮播",this.swipe);
    },

    // 横向滚动条
    async getAllDonateRecord() {
      const result = await this.$http.post("/donates/getAllDonateRecord");
      console.log("首页--横向滚动条", result);
      // todo
      this.allDonateRecord = result.data;
    },

    // 交流合作
    async getSchool() {
      const result = await this.$http.get("/schoolEnterprise/getAllEnterprise");
      console.log("首页--合作交流获取", result);
      // todo
      // this.schoolList = result.data;
      const list = result.data.filter((item, index) => {
        return index === result.data.findIndex((r) => r.id === item.id);
      });
      this.schoolList = list
      console.log("首页--合作交流过滤", this.schoolList);
      // this.schoolList = result.data.filter((item, index) => {
      //   return index === result.data.findIndex((r) => r.id === item.id);
      // });
    },

    // 校友活动
    async getActive() {
      const result = await this.$http.get(
        "/schoolActivity/getAllAchievementList",
        {
          params: { currentPage: 1, perpage: 4, 总数: 4 },
        }
      );
      console.log("首页--校友活动", result);
      this.active = result.data.list;
    },
    // 我的消息
    async getMsg() {
      this.notice = [];
      this.noticeNum = 0;
      const result = await this.$http.get("/myMsg/getWeiDu", {
        params: { userId: this.userId },
      });
      console.log("我的消息", result.data.list);

      // result.data.list.forEach((item) => {
      //   console.log("item消息", item);
      //   if (item.isRead == 0) {
      //     this.notice.push(item);
      //     // this.notice = item.data.list;
      //   }
      // });
      // this.notice = result.data.list;
      this.noticeNum = result.data.num;
      this.notice = result.data.list;
      console.log("首页--我的消息获取this.notice", this.notice);
    },
    // 各地校友
    async getClub() {
      const result = await this.$http.get("/branch/getAllBranchListInHomePage");
      console.log("首页--各地校友获取", result);
      // todo
      this.club = result.data;
    },

    // 校友资源
    async getAlumnus() {
      const result = await this.$http.get(
        "/amresources/getAlumniInDetailList",
        {
          params: {
            city: "",
            industry: "",
            name: "",
            sex: "",
            college: "",
            major: "",
            xuejie: "",
            xueli: "",
            danwei: "",
            hangye: "",
            hobby: "",
            userId: window.localStorage.getItem("user_id"),
            currentPage: 1,
            perPage: 4,
            bigShot: 0,
          },
        }
      );
      this.alumnus = result.data.list;

      console.log("首页--校友资源获取", this.alumnus);
    },
    async getQuestionnaire() {
      const result = await this.$http.get(
        "/questionnaire/getQuestionnaireListInHomePage",
        {
          params: { currentPage: 1, perpage: 1 },
        }
      );
      console.log("首页-问卷调查--result", result.data.list);
      this.questionnaire = result.data.list;
      // if (this.questionnaire == "") {
      //   document.getElementById("questionnaireId").remove();
      // }
    },
    async gotoActiveDetial(item) {
      // if (!(await this.toRealName())) {
      //   return;
      // }
      return this.$router.push({
        path: "/activeDetails",
        query: { title: item.sh_title },
      });
    },
    async gotoMeetingDetail(id) {
      if (!(await this.toRealName())) {
        return;
      }
      return this.$router.push({
        path: "/meetingDetails",
        query: { schoolBranchId: id },
      });
      // alert("正在建设中");
    },
    async gotoAlumnusDetail(aUserId) {
      // if (!(await this.toRealName())) {
      //   return;
      // }
      return this.$router.push({
        path: "/alumniDetailNew",
        query: {
          alumniId: aUserId,
          // alumniId:43995313
        },
      });
    },
    gotoNotice() {
      return this.$router.push("/alumnusActive");
    },
    async gotoAlumniResources() {
      // if (!(await this.toRealName())) {
      //   return;
      // }
      return this.$router.push("/alumniResourcesNew");
    },
    // 校友卡
    async gotoAlumniCard() {
      // if (!(await this.toRealName())) {
      //   return;
      // }
      return this.$router.push("/alumniCard");
      //alert("正在建设中");
    },
    // 校友卡
    async gotoHommieList() {
      // if (!(await this.toRealName())) {
      //   return;
      // }
      return this.$router.push("/hommieList");
      //alert("正在建设中");
    },
    gotoDonation() {
      return this.$router.push("/donationIndex");
      // alert("正在建设中");
    },
    /* gotoAppointment() {
      return this.$router.push("/appointment");
    }, */
    gotoAchievement() {
      alert("正在建设中");
      // return this.$router.push("/achievementsList");
    },
    async gotoActiveList() {
      // if (!(await this.toRealName())) {
      //   return;
      // }
      return this.$router.push("/activeList");
    },

    // 交流合作
    async gotoSchoolRrunEnterprise() {
      return this.$router.push("/schoolRrunEnterprise");
    },

    async getScoolDetail(item) {
      return this.$router.push({
        path: "/schoolDetaile",
        query: { id: item.id },
      });
    },

    //各地校友--更多
    async gotoAlumniMeeting() {
      // if (!(await this.toRealName())) {
      //   return;
      // }
      return this.$router.push("/alumniMeeting");
    },
    // 各地校友--详情
    getBranchInDetai(id) {
      return this.$router.push({
        path: "/alumniDetail",
        query: {
          id: id,
        },
      });
    },

    gotoService() {
      return this.$router.push("/service");
    },
    /* gotoSiginIn() {
      return this.$router.push("/siginIn");
    }, */
    gotoQuestionnaireList() {
      return this.$router.push("/questionnaireList");
    },
    gotoQuestionnaireDetail(id) {
      return this.$router.push({
        path: "/questionnaireDetail",
        query: { id: id },
      });
    },

    // 滚动列表查看详情
    handleClick(item) {
      console.log(item);
      // todo
      // 跳转页面
      return this.$router.push({
        path: "/alumnusActive",
        params: item,
      });
    },
    // 滚动
    scrollUp() {
      this.timer = setInterval(() => {
        this.animate = true; // 向上滚动的时候需要添加动画
        setTimeout(() => {
          this.notice.push(this.notice[0]); // 将数组的第一个元素添加到数组最后一个
          this.notice.shift(); // 删除数组的第一个元素
          this.animate = false;
        }, 500);
      }, 1000);
    },
    //鼠标移上去停止
    stop() {
      clearInterval(this.timer);
    },
    //鼠标离开继续
    up() {
      this.scrollUp();
    },
  },
  beforeDestroy() {
    this.stop();
  },
};
</script>

<style lang="less" scoped>
.index-box {
  background: #edf6f3;
  position: relative;
}
.swipeImg {
  height: 200px;
  width: 100%;
}
.scrolling {
  width: 90vw;
  height: 40px;
  margin-left: 5vw;
  background-color: #fff;
  border-radius: 10px;
  margin-top: 10px;
  display: flex;
  .imgjb {
    width: 22vw;
    height: 40px;
    display: flex;
    .nor {
      display: flex;
      width: 30px;
      height: 30px;
      line-height: 15px;
      border-radius: 50%;
      margin-top: 5px;
      margin-left: 12px;
      background: #f3f3f3;
      .btnGonggaoImg {
        display: flex;
        width: 20px;
        height: 20px;
        margin-left: 5px;
        margin-top: 5px;
      }
      .nor-txt {
        display: flex;
        min-width: 10px;
        width: auto;
        padding: 4px;
        height: 10px;
        line-height: 10px;
        display: inline-block;
        border-radius: 50%;
        font-size: 0.8rem;
        color: rgb(255, 255, 255);
        text-align: center;
        margin-top: -5px;
        background: #ff2e00;
      }
    }
  }
  .listscroll {
    width: 58vw;
    height: 40px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .listscroll-box {
      width: 65vw;
      height: 40px;
      display: flex;
      flex-direction: column;
      .list-item {
        height: 40px; /* 你可以根据需要调整这个值 */
        line-height: 35px; /* 垂直居中 */
        cursor: pointer; /* 鼠标悬停时变为手型，表示可点击 */
        transition: top 0.5s;
      }
      .noticeTitle {
        width: 55vw;
        margin: 5px 5px 5px 3px;
        font-size: 0.95rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .noticeTitle-rq {
      display: flex;
      height: 40px;
      justify-content: center;
      line-height: 40px;
      color: #868686;
      font-size: 0.95rem;
    }
  }
  .imgjb-r {
    width: 15vw;
    height: 40px;
    display: flex;
    .imgjbGengduo {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 0.95rem;
      color: #9a9a9a;
    }
    .norimg {
      padding-left: 5px;
      width: 10px;
      height: 13px;
    }
  }
}

.notice {
  position: relative;
  margin-top: 26px;
  background-color: white;
  left: 5%;
  width: 90vw;
  border-radius: 15px;
  height: 15vh;
  box-sizing: border-box;
  border: 1px solid #e1e1e1;
}

.noticeImgDiv {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 2%;
}

.noticeImg {
  position: relative;
  width: 13vw;
  height: 13vw;
  max-height: 80px;
  max-width: 80px;
}

.van-badge {
  position: absolute;
  top: 0%;
  left: 70%;
}

.noticeTitleDiv {
  position: absolute;
  left: 19vw;
  top: 50%;
  height: 15vh;
  transform: translateY(-50%);
  width: 64vw;
}

.noticeTitleDateDiv {
  position: absolute;
  left: 70%;
  top: 50%;
  transform: translateY(-50%);
  width: 30%;
}

.noticeTitleDate {
  margin: 10px 0 10px 0;
  font-size: 1.1rem;
  color: #999999;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}

.noticeMore {
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
}

.resources {
  margin-top: 33px;
  position: relative;
  left: 5%;
  width: 90vw;
}

.resourcesImg {
  width: 90vw;
}

.resourcesTitle {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 20%;
  font-size: 1.5em;
  font-weight: bold;
  color: #333333;
}

.resourcesWord {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 60%;
  white-space: nowrap;
  color: #666666;
  font-size: 1em;
}
.cardAndDonation {
  position: relative;
  width: 90vw;
  left: 5%;
  margin-top: 15px;
}

.card {
  position: relative;
  left: 0%;
  width: 47.5%;
  float: left;
}

.hommie {
  position: relative;
  left: 3%;
  width: 47.5%;
  float: left;
}

.hommieImg {
  width: 100%;
  image-rendering: -webkit-optimize-contrast;
}

.hommieTitle {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 5%;
  font-size: 1.1rem;
  font-weight: bold;
  color: #333333;
}

.hommieWord {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 25%;
  white-space: nowrap;
  color: #666666;
  font-size: 0.8rem;
}
.cardImg {
  width: 100%;
  image-rendering: -webkit-optimize-contrast;
}

.cardTitle {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 5%;
  font-size: 1.1rem;
  font-weight: bold;
  color: #333333;
}

.cardWord {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 25%;
  white-space: nowrap;
  color: #666666;
  font-size: 0.8rem;
}

.donation {
  position: relative;
  width: 47.5%;
  left: 5%;
  float: left;
}

.donationImg {
  width: 100%;
  image-rendering: -webkit-optimize-contrast;
}

.donationTitle {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 5%;
  font-size: 1.1rem;
  font-weight: bold;
  color: #333333;
}

.donationWord {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 25%;
  white-space: nowrap;
  color: #666666;
  font-size: 0.8rem;
}

.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  *zoom: 1;
}

.clearfix-fh:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix-fh {
  *zoom: 1;
}

.backSchool {
  position: relative;
  margin-top: 15px;
  width: 90vw;
  left: 5%;
}

.backSchoolImg {
  width: 100%;
}

.backSchoolTitle {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 15%;
  font-size: 1.5em;
  font-weight: bold;
  color: #333333;
}

.backSchoolWord {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 60%;
  white-space: nowrap;
  color: #666666;
}

.achievement {
  position: relative;
  margin-top: 15px;
  width: 90vw;
  left: 5%;

  .achievementImg {
    width: 100%;
  }

  .achievementTitle {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 15%;
    font-size: 1.5em;
    font-weight: bold;
    color: #333333;
  }

  .achievementWord {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 60%;
    white-space: nowrap;
    color: #666666;
  }
}

.schoolRrunEnterprise {
  margin-top: 15px;
  position: relative;
  left: 5%;
  width: 90vw;
}

.schoolImg {
  position: relative;
  display: block;
  width: 40%;
  height: 80px;
  border-radius: 10px;
  margin: 8px;
  border: 1px solid #ededed;
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor;
}
.school-box-txt {
  display: block;
  width: 53%;
  height: 80px;
  border-radius: 10px;
  margin: 8px;
  margin-left: 0px;
  display: flex;
  flex-direction: column;
  // border: 1px solid #999999;
}
.school-box-txt :nth-child(1) {
  margin-top: 0px;
  color: #000;
  font-size: 1rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.school-box-txt :nth-child(2) {
  margin-top: 2px;
  color: #6f6f6f;
  font-size: 0.95rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.school-box-txt :nth-child(3) {
  margin-top: 25px;
  color: #6f6f6f;
  font-size: 0.95rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-direction: row;
  display: flex;
  align-items: center;
}

.school-box-txt :nth-child(3) > img:first-child {
  width: 13px;
  height: 10px;
  margin-right: 5px;
}

.listCard {
  display: flex;
  border-radius: 0.5rem;
  height: 7rem;
}

.card-list__itemone {
  flex: 1;
  width: 50vw;
  margin: 5px 0 5px 0;
  margin-left: 5px;
  .active-list__item-location {
    position: relative;
    top: -1px;
    left: -1px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 5.03rem;
    height: 1.79rem;
    font-size: 0.95rem;
    color: #ffffff;
    border-top-left-radius: 10px;
    border-bottom-right-radius: 15px;
    background: #00706e;
    background-size: contain;
    z-index: 2;
  }
  .active-list__item-location-y {
    position: relative;
    top: -1px;
    left: -1px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 5.03rem;
    height: 1.79rem;
    font-size: 0.95rem;
    color: #ffffff;
    border-top-left-radius: 8px;
    border-bottom-right-radius: 8px;
    background: #f79d27;
    background-size: contain;
    z-index: 2;
  }

  .headDiagram {
    position: relative;
    width: 90%;
    height: 100%;
    border-radius: 5px;
    top: -1.79rem;
    z-index: 0;
    image-rendering: -moz-crisp-edges;
    image-rendering: -o-crisp-edges;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor;
  }
}

.dynamic-box-txt {
  display: block;
  width: 53%;
  height: 80px;
  border-radius: 10px;
  margin: 8px;
  margin-left: 0px;
  display: flex;
  flex-direction: column;
}
.dynamic-box-txt :nth-child(1) {
  margin-top: 0px;
  color: #000;
  font-size: 1rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dynamic-box-txt :nth-child(2) {
  margin-top: 45px;
  color: #6f6f6f;
  font-size: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.active {
  margin-top: 29px;
  position: relative;
  left: 5%;
  width: 90vw;
}

.titleDiv {
  height: 7vw;
}

.activeTitleIcon {
  float: left;
  width: 4px;
  height: 6vw;
  background-color: #00706e;
  border-radius: 15px;
}

.activeTitleWord {
  float: left;
  position: absolute;
  left: 10px;
  font-size: 18px;
  font-weight: bold;
  top: 1px;
}

.activeMore {
  float: right;
  color: #00706e;
  border: 0;
  background: #f5f5f5;
  top: 1px;
}

.activeDetailsDiv {
  padding-top: 5px;
  width: 85vw;
  padding-right: 20px;
  overflow-x: scroll;
  overflow-y: hidden;
}

.activeDetailsDiv::-webkit-scrollbar {
  display: none;
}

.activeDetails {
  background-color: white;
  width: 33.3%;
  margin: 5px;
  border-radius: 15px;
  border: 1px solid #e1e1e1;
  white-space: nowrap;
}
.gdxyDiv {
  width: 225vw;
  display: flex;
  flex-direction: row;
}

.activeDetails-fh {
  width: 33.3%;
  margin: 5px;
  float: left;
  border-radius: 15px;
}

.wenhua {
  color: #f10808;
  padding-left: 5px;
  float: left;
  font-weight: 600;
}
.activeDetailsTitle {
  width: 70%;
  color: #333333;
  padding: 10px 10px 0px 10px;
  float: left;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  white-space: pre-line;
}
.fh-Title {
  width: 100%;
  color: #333333;
  text-align: center;
  font-weight: bold;
  overflow: hidden;
  font-size: 1rem;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  white-space: pre-line;
  margin-top: 5px;
}
.city {
  z-index: 1;
  position: relative;
  width: 50px;
  font-size: 0.95rem;
  text-align: center;
  color: #fff;
  line-height: 18px;
  padding: 2px 5px 2px 5px;
  background: #00706e;
  border-top-left-radius: 15px;
  border-bottom-right-radius: 15px;
  top: -1px;
}

.tab {
  width: 46px;
  line-height: 8px;
  position: relative;
  font-size: 10px;
  text-align: center;
  margin-left: 62%;
  color: #fff;
  z-index: 1;
  /* 旋转45度 */
  transform: rotate(45deg);
  background: #00706e;
  transform: transparent(0.5rem) rotate(40deg);
  -ms-transform: rotateZ(40deg);
  -webkit-transform: rotateZ(40deg);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  top: 5px;
}
.tab-content {
  /* 定位内容使其显示在梯形内 */
  position: relative;
  color: white;
  /* 文字垂直居中 */
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.activeDetailsImg {
  height: 40vw;
  width: 100%;
  z-index: 0;
  position: relative;
  margin-top: -23px;
  border-radius: 15px 15px 0px 0px;
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor;
}
.line {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-top: 5px;
}

.line-o {
  color: #fd0b0b;
  font-size: 1rem;
  margin-left: 5px;
  padding-left: 5px;
  padding-right: 5px;
  font-weight: 600;
}
.line-t {
  color: #000000;
  font-size: 1rem;
  width: 75%;
  font-weight: 1000;
  overflow: hidden;
  text-overflow: ellipsis;
}
.line-Img {
  // width: 13px;
  // height: 15px;
  margin-left: 10px;
  padding-right: 5px;
  padding-top: 1px;
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor;
}
.line-xx {
  color: #767676;
  font-size: 0.85rem;
  width: 85%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.zhuangtai {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 20px;
  background: #000000;
  opacity: 0.5;
  margin-top: -20px;
}
.zhuangtai-o {
  color: #fbfbfb;
  font-size: 0.95rem;
  margin-left: 5px;
  width: 35%;
  line-height: 20px;
}
.zhuangtai-t {
  color: #fbfbfb;
  font-size: 0.95rem;
  width: 60%;
  text-align: right;
  line-height: 20px;
}

.fh-Img {
  display: block;
  height: 35vw;
  width: 50vw;
  border: 1px solid #e1e1e1;
  border-radius: 15px;
  font-size: 0.85rem;
  text-align: center;
  line-height: 35vw;
  color: #767676;
  image-rendering: -webkit-optimize-contrast;
}

.activeDetailsTime {
  width: 31%;
  float: left;
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 5px;
  padding-bottom: 10px;
  color: #666666;
  font-size: 0.9rem;
}

.club {
  margin-top: 29px;
  position: relative;
  left: 5%;
  width: 90vw;
}

.clubDisplayDiv {
  display: flex;
  flex-direction: column;
  margin-top: 5px;
  height: 130px;
}

.clubDisplay {
  width: 300px;
  height: 130px;
  padding-left: 10px;
  display: flex;
  flex-direction: column;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.clubImg {
  width: 300px;
  height: 100px;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
}
.clubName {
  width: 300px;
  margin-top: 5px;
  font-size: 16px;
  text-align: center;
  font-weight: 1000;
}

.driver {
  margin: 15px 0;
  width: 100%;
  height: 1px;
  background: #dedede;
}

.alumnus {
  margin-top: 15px;
  position: relative;
  left: 5%;
  width: 90vw;
}

.alumnusDiv {
  padding-top: 5px;
  overflow-x: scroll;
  overflow-y: hidden;
}

.alumnusDiv::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
}

.alumni-card-box {
  margin-top: 5px;
}

.alumnusDisplay {
  position: relative;
  width: 22.5%;
  height: 38vw;
  margin: 5px;
  white-space: nowrap;
  border-radius: 15px;
  float: left;
  background-color: white;
  border: 1px solid #e1e1e1;
}

.alumnusDisplayImg {
  width: 33%;
  height: 12.6vw;
  border-radius: 999px;
  position: absolute;
  left: 50%;
  top: 10%;
  transform: translateX(-50%);
}

.sexDiv {
  position: absolute;
  left: 60%;
  top: 10%;
}

.sex {
  width: 15px;
  height: 15px;
}

.alumnusDisplayAdress {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translateX(-50%);
  color: #00706e;
  font-size: 0.9em;
}

.nameAndDissertation {
  position: absolute;
  width: 65%;
  top: 60%;
  left: 50%;
  transform: translateX(-50%);
}

.alumnusDisplayName {
  float: left;
}

.alumnusDisplayDissertation {
  float: right;
  font-size: 0.9em;
  color: #666666;
}

.alumnusDisplayResources {
  position: absolute;
  font-size: 0.9em;
  color: #666666;
  top: 70%;
  text-align: center;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: pre-line;
}

.questionnaire {
  margin-top: 10px;
  position: relative;
  left: 5%;
  width: 90vw;
}

.questionnaireDiv {
  margin: 10px 0 0 0;
  position: relative;
}

.questionnaireImg {
  width: 90vw;
}

.questionnaireName {
  position: absolute;
  left: 5%;
  top: 23%;
  font-size: 1.1rem;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  color: #000;
}

.questionnaireTime {
  position: absolute;
  left: 5%;
  top: 55%;
  width: 58%;
  font-size: 0.8em;
  color: #666666;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}

.anim {
  transition: all 0.5s;
  margin-top: -30px;
}

.donationRolling {
  position: relative;
  width: 100%;
  line-height: 2px;
  color: #097573;
  display: flex;
  flex-direction: row;
}
.scroll-container {
  white-space: nowrap;
  position: relative;
  height: 20px;
  width: 100%;
  line-height: 20px;
  margin-top: 5px;
}

.scroll-content {
  display: inline-block;
  animation: scroll-left 10s linear infinite;
  display: flex;
  flex-direction: row;
}
.scroll-content-donation {
  padding-left: 10px;
  padding-right: 10px;
  font-size: 0.95rem;
}

@keyframes scroll-left {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(-100%);
  }
}

.xyhdDiv {
  width: 225vw;
  display: flex;
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue